import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { RouterButton } from '../components/RouterButton';
import { RouterFab } from '../components/RouterFab';
import { ReviewsList } from './components/ReviewsList';

const REVIEWS_GRID_KEY = 'landing:reviews';

export const Landing = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ width: '100%', minWidth: 300, maxWidth: 1200, mx: 'auto' }}>
            <Stack spacing={2}>
                {isMobile ? (
                    <RouterFab
                        color="primary"
                        to="/reviews/start"
                        aria-label="Start review"
                        sx={{ position: 'fixed', bottom: 24, right: 24 }}
                    >
                        <AddIcon />
                    </RouterFab>
                ) : (
                    <Box>
                        <RouterButton variant="contained" to="/reviews/start" startIcon={<AddCircleIcon />}>
                            Start Review
                        </RouterButton>
                    </Box>
                )}

                <ReviewsList storageKey={REVIEWS_GRID_KEY} />
            </Stack>
        </Box>
    );
}
